import Sample from "../components/Sample";
import { useNavigate } from "react-router-dom";

export default function NewsSection() {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate("/allscans");
  };

  return (
    <div className="sample-section">
      <div className="live-scans-header">
        <div className="header-with-dot">
          <div className="red-dot-recording" />
          <h2 className="section-title">Live Community Scans</h2>
        </div>
        <p onClick={handleViewAll} style={{ cursor: "pointer" }}>
          View all uploaded files →
        </p>
      </div>
      {/* <p className="sample-text">
        Lacking malware for analysis? Varist has prepared several samples. Click
        to explore
      </p> */}
      <div className="sample-library">
        <div className="samples-list">
          <Sample />
        </div>
      </div>
    </div>
  );
}
